import { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { FiLogOut, FiMenu, FiUser } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "./../assets/img/logo.png";
import defaultProfile from "./../assets/img/default-profile.png";
import { clearAuthSession, dispatchStorageSync } from "../services/sessionStorage";

const MainHeader = () => {
    const [scroll, setScroll] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const checkLoginStatus = () => {
        const token = localStorage.getItem("authToken");
        setIsLoggedIn(Boolean(token));
    };

    useEffect(() => {
        checkLoginStatus();
        setShowProfileMenu(false);
    }, [location]);

    useEffect(() => {
        const handleStorageChange = () => {
            checkLoginStatus();
        };

        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);

    useEffect(() => {
        const onScroll = () => {
            setScroll(window.scrollY >= 60);
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const handleLogout = () => {
        clearAuthSession();
        dispatchStorageSync();
        navigate("/");
    };

    const isHome = location.pathname === "/";
    const isJobs = location.pathname.startsWith("/lowongan-kerja");
    const isStatusLamaran = location.pathname.startsWith("/status-lamaran");

    return (
        <header className={`headerMain ${scroll ? "navresize" : "naviddle"} fixed-top`}>
            <Navbar collapseOnSelect expand="lg">
                <Container>
                    <Navbar.Brand href="/">
                        <img src={logo} className="logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav">
                        <FiMenu />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ms-auto align-items-center gap-4">
                            <Nav.Link href="/" className={isHome ? "active" : ""}>
                                Beranda
                            </Nav.Link>

                            <Nav.Link href="/lowongan-kerja" className={isJobs ? "active" : ""}>
                                Lowongan Pekerjaan
                            </Nav.Link>

                            {isLoggedIn && (
                                <Nav.Link href="/status-lamaran" className={isStatusLamaran ? "active" : ""}>
                                    Lamaran Saya
                                </Nav.Link>
                            )}

                            {isLoggedIn ? (
                                <div className="profile-menu-wrapper">
                                    <img
                                        src={defaultProfile}
                                        alt="Profile"
                                        className="profile-picture"
                                        onClick={() => setShowProfileMenu((current) => !current)}
                                        style={{ cursor: "pointer" }}
                                    />
                                    {showProfileMenu && (
                                        <div className="profile-dropdown">
                                            <button
                                                className="profile-dropdown__item"
                                                onClick={() => {
                                                    setShowProfileMenu(false);
                                                    navigate("/profil");
                                                }}
                                            >
                                                <FiUser /> Lihat Profil
                                            </button>
                                            <button className="logout-btn" onClick={handleLogout}>
                                                <FiLogOut /> Logout
                                            </button>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <Nav.Link href="/login" className="btn-login">
                                    Login
                                </Nav.Link>
                            )}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default MainHeader;
